module.exports = __webpack_public_path__ + "img/07-min.496728a7.jpg";